<base-section [index]="index" [section]="section">
  <div class="grid grid-section md-grid-cols-10">
    <div class="col-span-1 md-col-span-6">
      <ng-container *ngFor="let list of sectionRendered.list_contexts">
        <div class="content" *ngIf="list.active" >
          <div class="icon"
               *ngIf="
             (list.trigger|find:ContextTriggers.IMPORTANT) ||
             (list.trigger|find:ContextTriggers.WINDY) ||
             (list.trigger|find:ContextTriggers.SUNNY) ||
             (list.trigger|find:ContextTriggers.EVENING) ||
             (list.trigger|find:ContextTriggers.WEEKEND) ||
             (list.trigger|find:ContextTriggers.RAINY)
        ">
            <i class="lvi-thel-meteo-soleil" *ngIf="(list.trigger|find:ContextTriggers.SUNNY) && !(list.trigger|find:ContextTriggers.IMPORTANT)"></i>
            <i class="lvi-thel-meteo-pluie" *ngIf="(list.trigger|find:ContextTriggers.RAINY) && !(list.trigger|find:ContextTriggers.IMPORTANT)"></i>
            <i class="lvi-thel-vent" *ngIf="(list.trigger|find:ContextTriggers.WINDY) && !(list.trigger|find:ContextTriggers.IMPORTANT)"></i>
            <i class="lvi-thel-soiree" *ngIf="(list.trigger|find:ContextTriggers.EVENING) && !(list.trigger|find:ContextTriggers.IMPORTANT)"></i>
            <i class="lvi-thel-dimanche" *ngIf="(list.trigger|find:ContextTriggers.WEEKEND) && !(list.trigger|find:ContextTriggers.IMPORTANT)"></i>
            <i class="lvi-thel-info" *ngIf="list.trigger|find:ContextTriggers.IMPORTANT"></i>
          </div>
          <div *ngIf="list.introduction || list.title">
            <h2 class="h2" [ngClass]="{'h-icon':
             (list.trigger|find:ContextTriggers.IMPORTANT) ||
             (list.trigger|find:ContextTriggers.WINDY) ||
             (list.trigger|find:ContextTriggers.SUNNY) ||
             (list.trigger|find:ContextTriggers.EVENING) ||
             (list.trigger|find:ContextTriggers.WEEKEND) ||
             (list.trigger|find:ContextTriggers.RAINY)}" [innerHTML]="list.title"></h2>
            <div class="introduction" [innerHTML]="list.introduction"></div>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="col-span-1 md-col-span-4 overflow-hidden">
      <div class="context-buttons overflow-auto">
        <button class="button" [ngClass]="{'active':list.active}" *ngFor="let list of sectionRendered.list_contexts" (click)="onActiveClick(list)" [innerHTML]="list.tabname"></button>
      </div>
    </div>
  </div>
  <div class="context-content-container" *ngFor="let list of sectionRendered.list_contexts">
    <div @toggleTrigger class="grid grid-section gap-l overflow-hidden" *ngIf="list.active">
      <div class="col-span-1 overflow-hidden">
        <div class="currently-pages-container flex flex-column height-full">
          <div class="pages-title">
            <div class="button-group">
            </div>
          </div>
          <div class="pages-container flex-1 flex flex-column height-full width-full" [ngClass]="{'active':list.active}" >
            <div class="grid md-grid-cols-3 gap-l p-0 list-pages-container flex-1 height-full width-full">
              <tiny-post class="col-1" *ngFor="let page of list.pages|tinyPostsFromIds:'include'|async" [post]="page"></tiny-post>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</base-section>
